import React, { Component, Fragment } from 'react';

import { ButtonIcon } from 'components/button';
import { Tag } from 'components/cosmos/tag';
import { DropdownItem } from 'components/dropdown';
import { InputDropdown } from 'components/input';
import { I18n, translate } from 'components/translate';
import Number from 'helpers/Number';
import { isObject } from 'helpers/Object';
import { inject } from 'mobx-react';
import { AudiencePromoteProduct } from 'modules/audience';
import { ClassesService } from 'modules/content';
import { FeatureToggles, FeatureToggleService } from 'modules/featureToggle';
import { UiService } from 'modules/ui';
import { ALERT } from 'modules/ui/constants';
import {
  UserManagerService,
  UserManagerStore,
  UsersListTrackingService
} from 'modules/userManager';
import { KNOWN_ERROS, USER_STATUS } from 'modules/userManager/constants';
import DeepSearchService from 'modules/userManager/userSearch/deepSearch/DeepSearchService';
import PropTypes from 'prop-types';

import BulkActionErrorModal from './BulkActionErrorModal';
import BulkActionModal from './BulkActionModal';
import UserReasonBlockModal from './components/UserReasonBlockModal';
import { isToggleReasonModalEnabled } from './helpers/toggleReasonModal';

import './UsersListBulkActions.scss';

const bulkActionsPath = 'users_manager.users_list.bulk_actions';
const label = {
  block: 'general.block',
  unblock: 'general.unblock',
  class: `${bulkActionsPath}.change_class`,
  exportCSV: `${bulkActionsPath}.export_list_as_csv`,
  resendAccess: `${bulkActionsPath}.resend_access`,
  sendCommunication: `${bulkActionsPath}.send_communication`,
  resendAccessLimit: `alerts.${KNOWN_ERROS.RESEND_ACCESS_ABOVE_LIMIT.label}`
};
const massActionsTypes = {
  block: 'block',
  unblock: 'unblock',
  class: 'class',
  exportCSV: 'exportCSV',
  resendAccess: 'resendAccess',
  sendCommunication: 'sendCommunication'
};
const modal = {
  open: true,
  close: false
};

@inject(() => ({
  isFeaturePromoteProductModalEnabled: FeatureToggleService.isEnabled(
    FeatureToggles.PromoteProductModal
  )
}))
@translate()
class UsersListBulkActions extends Component {
  static propTypes = {
    t: PropTypes.func,
    isFeaturePromoteProductModalEnabled: PropTypes.bool
  };

  state = {
    actionModal: false,
    showErrorModal: false,
    showReasonBlockModal: false,
    showPromoteProductModal: false,
    formReasonBlockModal: {},
    classesList: [],
    membershipClass: '',
    open: false,
    usersChecked: [],
    massActionsType: '',
    loadPromoteProductModule: false
  };

  async componentDidMount() {
    this.dropdownIndicatorStyle = this.dropdownIndicatorStyle.bind(this);
    this.onMenuOpen = this.onMenuOpen.bind(this);
    this.blockAll = this.blockAll.bind(this);
    this.changeUsersClass = this.changeUsersClass.bind(this);
    this.setClass = this.setClass.bind(this);
    this.toogleModal = this.toogleModal.bind(this);
    this.toggleReasonBlockModal = this.toggleReasonBlockModal.bind(this);
    this.getActionChangeStatus = this.getActionChangeStatus.bind(this);
    this.setFormReasonBlockModal = this.setFormReasonBlockModal.bind(this);
    this.changeStatusReasonBlock = this.changeStatusReasonBlock.bind(this);
    this.resendAccess = this.resendAccess.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    const classesList = await ClassesService.getSelectFormatedClasses();
    const loadPromoteProductModule = true;

    this.setState({ classesList, loadPromoteProductModule });
  }

  async exportCSV() {
    const { t } = this.props;

    const {
      usersChecked = [],
      selectAll = false,
      isAnyUserChecked = false
    } = this.usersChecked || {};
    const exportCSV = t(label.exportCSV);
    const config = {};

    if (isAnyUserChecked) {
      const userData = this.getUserData(config, selectAll, usersChecked);

      this.toogleModal(modal.close);
      this.infoAlertMessage(exportCSV, ALERT.TIMEOUT.VERY_LONG);

      UserManagerService.exportLastSearchAsCSV(userData).then((fileURL) => {
        window.location.href = fileURL;
      });
    }
  }

  handleError(error) {
    const { data } = error || {};
    const { INVALID_ACTIONS } = KNOWN_ERROS;
    const invalidAction = isObject(data) && data?.errorCode === INVALID_ACTIONS;

    if (invalidAction) {
      UiService.setAlertError('blocked_user_invalid_action');
      return;
    }

    UiService.handleError(error);
  }

  setFormReasonBlockModal({ blockReason, blockReasonDescription }) {
    this.setState({
      formReasonBlockModal: {
        blockReason,
        blockReasonDescription
      }
    });
  }

  async changeStatusReasonBlock() {
    const { blockReason, blockReasonDescription } =
      this.state.formReasonBlockModal;
    const { usersChecked = [], selectAll = false } = this.usersChecked || {};
    const { BLOCKED_BY_OWNER } = USER_STATUS;
    const config = { status: BLOCKED_BY_OWNER };

    const userData = this.getUserData(config, selectAll, usersChecked);

    await UserManagerService.userChangeStatus({
      blockReason,
      blockReasonDescription,
      ...userData
    });

    this.toggleShowReasonModalBlock();

    this.infoAlertMessage(this.getActionBlockName(BLOCKED_BY_OWNER));
  }

  toggleShowReasonModalBlock() {
    this.setState((prevState) => ({
      showReasonBlockModal: !prevState.showReasonBlockModal
    }));
  }

  async userChangeStatus(selectedAll, usersChecked, isBlock) {
    const { BLOCKED_BY_OWNER, ACTIVE } = USER_STATUS;
    const config = { status: isBlock ? BLOCKED_BY_OWNER : ACTIVE };

    await UserManagerService.userChangeStatus(
      this.getUserData(config, selectedAll, usersChecked)
    );
    this.infoAlertMessage(this.getActionBlockName(isBlock));

    this.toogleModal(modal.close);
  }

  async blockAll(isBlock) {
    const {
      usersChecked = [],
      selectAll = false,
      isAnyUserChecked = false
    } = this.usersChecked || {};

    if (isAnyUserChecked) {
      await this.userChangeStatus(selectAll, usersChecked, isBlock);

      this.toogleModal(modal.close);
    }
  }

  async changeUsersClass() {
    const { t } = this.props;
    const { membershipClass, usersChecked, selectAll } = this.state;
    const classAction = t(label.class);

    const config = { classId: membershipClass.value };

    await UserManagerService.userChangeClass(
      this.getUserData(config, selectAll, usersChecked)
    );

    this.infoAlertMessage(classAction);
    this.toogleModal(modal.close);
  }

  async resendAccess() {
    const { t } = this.props;

    const {
      usersChecked = [],
      selectAll = false,
      isAnyUserChecked = false
    } = this.usersChecked || {};
    const resendAction = t(label.resendAccess);
    const config = {};

    if (isAnyUserChecked) {
      await UserManagerService.bulkResendAccess(
        this.getUserData(config, selectAll, usersChecked)
      );

      this.infoAlertMessage(resendAction);

      this.toogleModal(modal.close);
    }
  }

  getActionBlockName = (isBlock) => {
    const { t } = this.props;

    return isBlock ? t(label.block) : t(label.unblock);
  };

  openResendLimitModal = () => this.setState({ showErrorModal: true });

  closeResendLimitModal = () => this.setState({ showErrorModal: false });

  openPromoteProductModal = () => {
    const { isAnyUserChecked = false } = this.usersChecked || {};

    if (isAnyUserChecked) {
      this.setState({ showPromoteProductModal: true });
    }

    UsersListTrackingService.sendSendCommunicationsEvent();
  };

  closePromoteProductModal = () =>
    this.setState({ showPromoteProductModal: false });

  getPromoteModalFilters = () => {
    const { content = [], selectAll } = UserManagerStore;
    const usersChecked = content.filter((item) => item._checked);
    const config = {};

    return this.getUserData(config, selectAll, usersChecked);
  };

  getActionChangeStatus = (open, block) => {
    return isToggleReasonModalEnabled()
      ? this.toggleReasonBlockModal()
      : this.toogleModal(open, block);
  };

  toggleReasonBlockModal = (massActionsType = '') => {
    const {
      usersChecked = [],
      selectAll = false,
      isAnyUserChecked = false
    } = this.usersChecked || {};

    if (isAnyUserChecked) {
      this.setState({
        actionModal: false,
        open: false,
        usersChecked,
        selectAll,
        membershipClass: '',
        massActionsType
      });
    }

    this.toggleShowReasonModalBlock();
  };

  toogleModal(actionModal, massActionsType = '') {
    const {
      usersChecked = [],
      selectAll = false,
      isAnyUserChecked = false
    } = this.usersChecked || {};

    if (isAnyUserChecked) {
      this.setState({
        actionModal,
        open: false,
        usersChecked,
        selectAll,
        membershipClass: '',
        massActionsType
      });
    }
  }

  getUserData(config, selectedAll, usersChecked) {
    const userData = config;

    if (selectedAll) {
      userData.search = { filters: DeepSearchService.filters };
    } else {
      userData.userAreaIds = usersChecked.map((item) => item.id);
    }

    return userData;
  }

  setClass(value) {
    this.setState({ membershipClass: value });
  }

  onMenuOpen() {
    this.setState({ open: !this.state.open });
  }

  dropdownIndicatorStyle() {
    const transition = 'transform .3s linear';

    return this.state.open
      ? {
          transition,
          transform: 'rotate(180deg)'
        }
      : { transition };
  }

  infoAlertMessage(action) {
    const { t } = this.props;

    UiService.setAlertInfo(t('mass_actions_success_message'), {
      action
    });
  }

  isBelowResendLimit = () => {
    const { totalElements = 0, selectAll = false } = UserManagerStore;
    const { resendAccessLimit } = UserManagerService;

    return (
      !selectAll || totalElements <= resendAccessLimit || !resendAccessLimit
    );
  };

  get resendLimitMsg() {
    const formatedNumber = Number.format(UserManagerService.resendAccessLimit);

    return this.props.t(label.resendAccessLimit, {
      data: { resend_limit: formatedNumber }
    });
  }

  get usersChecked() {
    const { t } = this.props;

    const { content = [], selectAll } = UserManagerStore;
    const usersChecked = content.filter((item) => item._checked);
    const isAnyUserChecked = selectAll || usersChecked.length;

    if (!isAnyUserChecked) {
      return UiService.setAlertWarning(t('mass_actions_warning_select_users'));
    }

    return { usersChecked, selectAll, isAnyUserChecked };
  }

  get actionsList() {
    const defaultActions = [
      {
        icon: 'download',
        label: label.exportCSV,
        handler: () => this.toogleModal(modal.open, massActionsTypes.exportCSV)
      },
      {
        icon: 'classes',
        label: label.class,
        handler: () => this.toogleModal(modal.open, massActionsTypes.class)
      },
      {
        icon: 'retry',
        label: label.resendAccess,
        handler: () =>
          this.isBelowResendLimit()
            ? this.toogleModal(modal.open, massActionsTypes.resendAccess)
            : this.openResendLimitModal()
      },
      {
        icon: 'lock',
        label: label.block,
        handler: () =>
          this.getActionChangeStatus(modal.open, massActionsTypes.block)
      },
      {
        icon: 'unlock',
        label: label.unblock,
        handler: () => this.toogleModal(modal.open, massActionsTypes.unblock)
      }
    ];

    if (this.props.isFeaturePromoteProductModalEnabled) {
      defaultActions.push({
        icon: 'envelope',
        label: label.sendCommunication,
        tag: (
          <Tag variation="blue" size="sm" className="_ml-auto _mr-0">
            <span className="_text-1">
              <I18n label="general.new" />
            </span>
          </Tag>
        ),
        handler: () => this.openPromoteProductModal()
      });
    }

    return defaultActions;
  }

  showModalReasonBlock() {
    const { showReasonBlockModal } = this.state;
    const { content = [], selectAll } = UserManagerStore;

    const usersChecked = content.filter((item) => item._checked);
    const isAnyUserChecked = selectAll || usersChecked.length;

    return (isAnyUserChecked && showReasonBlockModal) || null;
  }

  showTitleModalReasonBlockInPlural() {
    const { content = [], selectAll } = UserManagerStore;
    const usersChecked = content.filter((item) => item._checked);

    return selectAll || usersChecked.length > 1;
  }

  sendEventClickActionsDropdown(state) {
    if (!state.active) {
      UsersListTrackingService.sendOpenBulkActionsSelectEvent();
    }
  }

  render() {
    const { t, isFeaturePromoteProductModalEnabled } = this.props;
    const {
      actionModal,
      showErrorModal,
      membershipClass,
      classesList,
      massActionsType,
      loadPromoteProductModule,
      showPromoteProductModal
    } = this.state;

    const showModalReasonBlock = this.showModalReasonBlock();

    return (
      <Fragment>
        <InputDropdown
          className="users__list__bulk__actions"
          selected={<I18n label="content_list.mass_actions" />}
          onClick={this.sendEventClickActionsDropdown}
        >
          {this.actionsList.map((action) => (
            <DropdownItem
              key={`action-key-${action.label}`}
              onClick={action.handler}
              id={action.icon}
            >
              <ButtonIcon icon={action.icon} size="small" transparent>
                <I18n label={action.label} />
                {action.tag}
              </ButtonIcon>
            </DropdownItem>
          ))}
        </InputDropdown>

        {actionModal && (
          <BulkActionModal
            label={label}
            membershipClass={membershipClass}
            classesList={classesList}
            massActionsType={massActionsType}
            bulkActionsPath={bulkActionsPath}
            modal={modal}
            dropdownIndicatorStyle={this.dropdownIndicatorStyle}
            onMenuOpen={this.onMenuOpen}
            blockAll={this.blockAll}
            changeUsersClass={this.changeUsersClass}
            setClass={this.setClass}
            toogleModal={this.toogleModal}
            resendAccess={this.resendAccess}
            exportCSV={this.exportCSV}
          />
        )}

        {showModalReasonBlock && (
          <UserReasonBlockModal
            titlePlural={this.showTitleModalReasonBlockInPlural()}
            toggleModal={this.toggleReasonBlockModal}
            changeStatus={this.changeStatusReasonBlock}
            setForm={this.setFormReasonBlockModal}
            handleError={this.handleError}
            isOpen={showModalReasonBlock}
          />
        )}

        {showErrorModal && (
          <BulkActionErrorModal
            bodyMsg={this.resendLimitMsg}
            onClose={this.closeResendLimitModal}
            title={t('general.max_quantity')}
          />
        )}

        {isFeaturePromoteProductModalEnabled && loadPromoteProductModule && (
          <AudiencePromoteProduct
            showModal={showPromoteProductModal}
            onClose={this.closePromoteProductModal}
            filters={this.getPromoteModalFilters()}
          />
        )}
      </Fragment>
    );
  }
}

export default UsersListBulkActions;
